import React from 'react';
import { motion } from 'framer-motion';
import { Wallet, CreditCard, PiggyBank, TrendingUp, Calendar, PieChart } from 'lucide-react';
export function Features() {
  const features = [{
    icon: Wallet,
    title: 'Registro de Ingresos',
    description: 'Anotá todo lo que entra para saber tu capacidad real de gasto.'
  }, {
    icon: CreditCard,
    title: 'Control de Gastos',
    description: 'Categorizá tus salidas y detectá gastos hormiga innecesarios.'
  }, {
    icon: PiggyBank,
    title: 'Seguimiento de Ahorros',
    description: 'Establecé metas y visualizá cómo crecen tus ahorros mes a mes.'
  }, {
    icon: TrendingUp,
    title: 'Gestión de Deudas',
    description: 'Ordená montos, cuotas y visualizá tu progreso para salir de ellas.'
  }, {
    icon: Calendar,
    title: 'Resúmenes Mensuales',
    description: 'Cierre automático de mes para ver tu rendimiento sin hacer cuentas.'
  }, {
    icon: PieChart,
    title: 'Estado Financiero Visual',
    description: 'Gráficos claros que te muestran tu situación de un vistazo.'
  }];
  return <section className="py-10 md:py-20 bg-white" data-id="element-53">
      <div className="container mx-auto px-4 md:px-6" data-id="element-54">
        <div className="text-center mb-8 md:mb-16" data-id="element-55">
          <h2 className="text-2xl md:text-4xl font-bold text-stone-900 mb-2 md:mb-4" data-id="element-56">
            Todo lo que incluye la plantilla
          </h2>
          <p className="text-sm md:text-lg text-stone-600 max-w-2xl mx-auto" data-id="element-57">
            Una herramienta completa pero simple, 100% editable en Google
            Sheets.
          </p>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-3 gap-3 md:gap-8" data-id="element-58">
          {features.map((feature, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="p-3 md:p-6 rounded-2xl bg-stone-50 border border-stone-100 hover:border-[#10b981]/30 transition-colors group" data-id="element-59">
              <div className="w-8 h-8 md:w-12 md:h-12 bg-white rounded-xl shadow-sm flex items-center justify-center mb-2 md:mb-4 group-hover:scale-110 transition-transform duration-300" data-id="element-60">
                <feature.icon className="w-4 h-4 md:w-6 md:h-6 text-[#10b981]" data-id="element-61" />
              </div>
              <h3 className="text-sm md:text-xl font-bold text-stone-900 mb-1 md:mb-2" data-id="element-62">
                {feature.title}
              </h3>
              <p className="text-xs md:text-base text-stone-600" data-id="element-63">
                {feature.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}